<script>
import BaseModal from 'dashboard/components/dahreply/BaseModal.vue';
import { useAlert } from 'dashboard/composables';
import StaffSelectionTable from '../../../../components/StaffSelectionTable.vue';

export default {
  name: "LinkStaffModal",
  components: {
    BaseModal,
    StaffSelectionTable,
  },

  props: {
    staffs: {
      type: Array,
      default: () => [],
    }
  },

  data() {
    return {
      isConfirming: false,
      isAllLoading: false,
      selectedStaffIds: this.staffs.map(s => s.staff.id),
    }
  },

  computed: {
    branchId() {
      return this.$route.params.branchId;
    },
  },

  methods: {
    async fetchStaff() {
      try {
        await this.$store.dispatch('branchStaff/fetchBranchStaff');
      } catch (err) {
        console.error(err);
        useAlert(`Failed to fetch staff list: ${err}`);
      }
    },

    handleSelectionChange(ids) {
      this.selectedStaffIds = ids;
    },

    async handleConfirm() {
      try {
        this.isConfirming = true;

        await this.$store.dispatch(
          'branchStaff/bulkAssignStaffToBranch',
          {
            branch_id: this.branchId,
            staff_ids: this.selectedStaffIds,
            update_mode: 'replace',
          }
        );

        useAlert('Staff linked to branch');
        this.$store.dispatch('onboarding/completeLocalTask', 'link_staff_to_branch');
        if(this.$route.query.onboarding === 'true') {
          this.$router.push(this.$route.path);
        }
        this.$emit('refresh');
        this.$emit('close');
      } catch (err) {
        console.error(err);
        useAlert(`Failed to link staff to branch: ${err}`);
      } finally {
        this.isConfirming = false;
      }
    },
  },

  async mounted() {
    this.isAllLoading = true;
    await this.fetchStaff();
    this.isAllLoading = false;
  }
};
</script>

<template>
  <BaseModal size="large" @close="$emit('close')">
    <template #title>
      Link Staffs
    </template>

    <!-- Integrated Table -->
    <StaffSelectionTable
      :initialSelectedIds="selectedStaffIds"
      @change="handleSelectionChange"
    />

    <template #footer>
      <div class="flex justify-end gap-3 mt-4">
        <woot-button color-scheme="secondary" @click="$emit('close')" :disabled="isAllLoading">
          Cancel
        </woot-button>
        <woot-button @click="handleConfirm" :disabled="isAllLoading" :is-loading="isConfirming">
          Link
        </woot-button>
      </div>
    </template>
  </BaseModal>
</template>